import React, { Component } from 'react'
import queryString from 'query-string'
import PasswordField from '../PasswordField'
import Api from '../../api'


const MissingToken = () => (
  <div>
    <p>Your password reset link has expired. Please try again.</p>
  </div>
)

class ResetPasswordWidget extends Component {
  api = new Api()
  state = {
    token: null,
    errors: [],
    loading: false,
    password: "",
    passwordConfirmation: ""
  }

  componentDidMount() {
    const parsed = queryString.parse(window.location.search)
    this.setState({token: parsed.token})
  }

  handleSubmission = (e) => {
    e.preventDefault()
    this.setState({loading: true})
    const { password, passwordConfirmation, token } = this.state
    this.api.performPasswordReset({password, passwordConfirmation, token}, (errors) => this.setState({errors, loading: false}))
  }

  render() {
    const { token, errors, loading, password, passwordConfirmation } = this.state

    if(token) {
      return (
        <form onSubmit={this.handleSubmission}>
          { errors.base && <div className="base-errors">{ errors["base"] }</div> }
          { errors.token && <div className="base-errors">{ errors["token"] }</div> }

          <PasswordField
            label="New Password"
            value={password}
            onChange={password => this.setState({password})}
            error={errors.password}
          />

          <PasswordField
            label="Confirm New Password"
            value={passwordConfirmation}
            onChange={passwordConfirmation => this.setState({passwordConfirmation})}
            error={errors.passwordConfirmation}
          />

          <input type="submit" value="Reset Password" disabled={loading} className={`login__form__submit ${loading ? 'loading' : ''}`} />
        </form>
      )
    }
    else {
      return <MissingToken />
    }
  }
}

export default ResetPasswordWidget



// WEBPACK FOOTER //
// ./src/components/ResetPasswordWidget/index.js